import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    id: "filters",
    class: "filters"
};
const _hoisted_2 = {
    ref: "ratingsContainer",
    class: "ratings"
};
const _hoisted_3 = { class: "ratings__details" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h3", { class: "details-title" }, "Rating", -1 /* HOISTED */);
const _hoisted_5 = { class: "details-reviews-count" };
const _hoisted_6 = { class: "details-reviews-average" };
const _hoisted_7 = { class: "details-reviews-filters" };
const _hoisted_8 = { class: "ratings-container" };
const _hoisted_9 = ["data-filter-type"];
const _hoisted_10 = {
    class: "ratings-container__stars-container",
    "aria-label": "star images showing a five star rating"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = { class: "ratings-container" };
const _hoisted_17 = ["data-filter-type"];
const _hoisted_18 = {
    class: "ratings-container__stars-container",
    "aria-label": "star images showing a four star rating"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = ["src"];
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
const _hoisted_23 = ["src"];
const _hoisted_24 = { class: "ratings-container" };
const _hoisted_25 = ["data-filter-type"];
const _hoisted_26 = {
    class: "ratings-container__stars-container",
    "aria-label": "star images showing a three star rating"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = ["src"];
const _hoisted_29 = ["src"];
const _hoisted_30 = ["src"];
const _hoisted_31 = ["src"];
const _hoisted_32 = { class: "ratings-container" };
const _hoisted_33 = ["data-filter-type"];
const _hoisted_34 = {
    class: "ratings-container__stars-container",
    "aria-label": "star images showing a two star rating"
};
const _hoisted_35 = ["src"];
const _hoisted_36 = ["src"];
const _hoisted_37 = ["src"];
const _hoisted_38 = ["src"];
const _hoisted_39 = ["src"];
const _hoisted_40 = { class: "ratings-container" };
const _hoisted_41 = ["data-filter-type"];
const _hoisted_42 = {
    class: "ratings-container__stars-container",
    "aria-label": "star images showing a one star rating"
};
const _hoisted_43 = ["src"];
const _hoisted_44 = ["src"];
const _hoisted_45 = ["src"];
const _hoisted_46 = ["src"];
const _hoisted_47 = ["src"];
const _hoisted_48 = { class: "models" };
const _hoisted_49 = { class: "models__details" };
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("h3", { class: "details-title" }, "Models", -1 /* HOISTED */);
const _hoisted_51 = { class: "details-filters" };
const _hoisted_52 = ["id", "value", "data-filter-type", "onChange"];
const _hoisted_53 = ["for"];
const _hoisted_54 = { class: "survey-type" };
const _hoisted_55 = { class: "survey-type__details" };
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("h3", { class: "details-title" }, "Type of Survey", -1 /* HOISTED */);
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("h4", { class: "details-sub-title" }, "Filter by:", -1 /* HOISTED */);
const _hoisted_58 = { class: "details-fitlers" };
const _hoisted_59 = ["id", "value", "data-filter-type", "onChange"];
const _hoisted_60 = ["for"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.filteredReviewsCount), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.filteredReviewsAverage), 1 /* TEXT */),
                    _createElementVNode("ul", _hoisted_7, [
                        _createElementVNode("li", _hoisted_8, [
                            _createElementVNode("span", {
                                class: "ratings-container__rating",
                                style: _normalizeStyle({ width: _ctx.maxRatingsLengthStylingWidth })
                            }, [
                                _createElementVNode("input", {
                                    id: "starsFive",
                                    type: "checkbox",
                                    "aria-label": "five star filter",
                                    "data-filter-type": _ctx.FilterTypeEnum.Rating,
                                    onChange: _cache[0] || (_cache[0] = ($event) => (_ctx.processFilter($event, _ctx.ratingFilterEnum.Five.toString())))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9)
                            ], 4 /* STYLE */),
                            _createElementVNode("span", _hoisted_10, [
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_11),
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_12),
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_13),
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_14),
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_15)
                            ])
                        ]),
                        _createElementVNode("li", _hoisted_16, [
                            _createElementVNode("span", {
                                class: "ratings-container__rating",
                                style: _normalizeStyle({ width: _ctx.maxRatingsLengthStylingWidth })
                            }, [
                                _createElementVNode("input", {
                                    id: "starsFour",
                                    type: "checkbox",
                                    "aria-label": "four star filter",
                                    "data-filter-type": _ctx.FilterTypeEnum.Rating,
                                    onChange: _cache[1] || (_cache[1] = ($event) => (_ctx.processFilter($event, _ctx.ratingFilterEnum.Four.toString())))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_17)
                            ], 4 /* STYLE */),
                            _createElementVNode("span", _hoisted_18, [
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_19),
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_20),
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_21),
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_22),
                                _createElementVNode("img", {
                                    src: _ctx.EmptyStarImage,
                                    alt: "empty star"
                                }, null, 8 /* PROPS */, _hoisted_23)
                            ])
                        ]),
                        _createElementVNode("li", _hoisted_24, [
                            _createElementVNode("span", {
                                class: "ratings-container__rating",
                                style: _normalizeStyle({ width: _ctx.maxRatingsLengthStylingWidth })
                            }, [
                                _createElementVNode("input", {
                                    id: "starsThree",
                                    type: "checkbox",
                                    "aria-label": "three star filter",
                                    "data-filter-type": _ctx.FilterTypeEnum.Rating,
                                    onChange: _cache[2] || (_cache[2] = ($event) => (_ctx.processFilter($event, _ctx.ratingFilterEnum.Three.toString())))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_25)
                            ], 4 /* STYLE */),
                            _createElementVNode("span", _hoisted_26, [
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_27),
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_28),
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_29),
                                _createElementVNode("img", {
                                    src: _ctx.EmptyStarImage,
                                    alt: "empty star"
                                }, null, 8 /* PROPS */, _hoisted_30),
                                _createElementVNode("img", {
                                    src: _ctx.EmptyStarImage,
                                    alt: "empty star"
                                }, null, 8 /* PROPS */, _hoisted_31)
                            ])
                        ]),
                        _createElementVNode("li", _hoisted_32, [
                            _createElementVNode("span", {
                                class: "ratings-container__rating",
                                style: _normalizeStyle({ width: _ctx.maxRatingsLengthStylingWidth })
                            }, [
                                _createElementVNode("input", {
                                    id: "starsTwo",
                                    type: "checkbox",
                                    "aria-label": "two star filter",
                                    "data-filter-type": _ctx.FilterTypeEnum.Rating,
                                    onChange: _cache[3] || (_cache[3] = ($event) => (_ctx.processFilter($event, _ctx.ratingFilterEnum.Two.toString())))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_33)
                            ], 4 /* STYLE */),
                            _createElementVNode("span", _hoisted_34, [
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_35),
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_36),
                                _createElementVNode("img", {
                                    src: _ctx.EmptyStarImage,
                                    alt: "empty star"
                                }, null, 8 /* PROPS */, _hoisted_37),
                                _createElementVNode("img", {
                                    src: _ctx.EmptyStarImage,
                                    alt: "empty star"
                                }, null, 8 /* PROPS */, _hoisted_38),
                                _createElementVNode("img", {
                                    src: _ctx.EmptyStarImage,
                                    alt: "empty star"
                                }, null, 8 /* PROPS */, _hoisted_39)
                            ])
                        ]),
                        _createElementVNode("li", _hoisted_40, [
                            _createElementVNode("span", {
                                class: "ratings-container__rating",
                                style: _normalizeStyle({ width: _ctx.maxRatingsLengthStylingWidth })
                            }, [
                                _createElementVNode("input", {
                                    id: "starsOne",
                                    type: "checkbox",
                                    "aria-label": "one star filter",
                                    "data-filter-type": _ctx.FilterTypeEnum.Rating,
                                    onChange: _cache[4] || (_cache[4] = ($event) => (_ctx.processFilter($event, _ctx.ratingFilterEnum.One.toString())))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_41)
                            ], 4 /* STYLE */),
                            _createElementVNode("span", _hoisted_42, [
                                _createElementVNode("img", {
                                    src: _ctx.FullStarImage,
                                    alt: "full star"
                                }, null, 8 /* PROPS */, _hoisted_43),
                                _createElementVNode("img", {
                                    src: _ctx.EmptyStarImage,
                                    alt: "empty star"
                                }, null, 8 /* PROPS */, _hoisted_44),
                                _createElementVNode("img", {
                                    src: _ctx.EmptyStarImage,
                                    alt: "empty star"
                                }, null, 8 /* PROPS */, _hoisted_45),
                                _createElementVNode("img", {
                                    src: _ctx.EmptyStarImage,
                                    alt: "empty star"
                                }, null, 8 /* PROPS */, _hoisted_46),
                                _createElementVNode("img", {
                                    src: _ctx.EmptyStarImage,
                                    alt: "empty star"
                                }, null, 8 /* PROPS */, _hoisted_47)
                            ])
                        ])
                    ])
                ])
            ], 512 /* NEED_PATCH */),
            _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("ul", _hoisted_51, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelFilters, (model) => {
                            return (_openBlock(), _createElementBlock("li", { key: model }, [
                                _createElementVNode("input", {
                                    id: model,
                                    type: "checkbox",
                                    value: model,
                                    "aria-label": "model",
                                    "data-filter-type": _ctx.FilterTypeEnum.Model,
                                    onChange: ($event) => (_ctx.processFilter($event, model))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_52),
                                _createElementVNode("label", { for: model }, _toDisplayString(model), 9 /* TEXT, PROPS */, _hoisted_53)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _hoisted_57,
                    _createElementVNode("ul", _hoisted_58, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveyTypeFilters, (surveyType) => {
                            return (_openBlock(), _createElementBlock("li", { key: surveyType }, [
                                _withDirectives(_createElementVNode("input", {
                                    id: surveyType,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.defaultSurveyType) = $event)),
                                    type: "radio",
                                    name: "surveyType",
                                    value: surveyType,
                                    "aria-label": "survey type",
                                    "data-filter-type": _ctx.FilterTypeEnum.SurveyType,
                                    onChange: ($event) => (_ctx.processFilter($event, surveyType))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_59), [
                                    [_vModelRadio, _ctx.defaultSurveyType]
                                ]),
                                _createElementVNode("label", { for: surveyType }, _toDisplayString(surveyType), 9 /* TEXT, PROPS */, _hoisted_60)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ])
        ])
    ]));
}
